// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"2959":"6f372e0fe0a8d6e08b7f","7513":"0747a4adb95e6d9cf44d","7786":"83164a03e8bad606c899"}[chunkId] + ".js";
};